import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';
import { CONVERSATIONS_PAGE_LIMIT } from 'Utilities/consts';

const { AI_COMPANION } = ANALYTICS_CATEGORIES;
const { LOAD } = SNOWPLOW_EVENTS;

interface TriggerAiCompanionHighConversationCountLoadedEventParams {
	totalConversations: number;
}

export const triggerAiCompanionHighConversationCountLoadedEvent = ({
	totalConversations,
}: TriggerAiCompanionHighConversationCountLoadedEventParams): void => {
	const eventPayload = getSnowplowEventPayload({
		category: AI_COMPANION,
		customData: { label: `total: ${totalConversations} limit: ${CONVERSATIONS_PAGE_LIMIT}` },
		name: 'dlr_ai_companion_high_conversation_count_loaded',
		schemaName: LOAD.SCHEMA,
		version: LOAD.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
